// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const VideoContainer = styled.div`
	display: flex;
	-webkit-box-pack: center;
	justify-content: center;
	position: relative;
	flex: 1 1 0%;
	background-color: black;
	overflow: hidden;
`;

// #####################################################
